import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { SubscriptionAssignment } from "@/redux/apis/subscription/types";
import { SubscriptionAssignmentState } from "./types";

const initialState: SubscriptionAssignmentState = {
  assignments: [],
  isLoading: false,
  error: null,
  hasShownWelcomeModal: false,
  showPlanSelectionModal: false,
  preSelectedPlanId: undefined,
  hasEverLoadedPaymentMethods: false,
};

export const subscriptionAssignmentSlice = createSlice({
  name: "subscriptionAssignment",
  initialState,
  reducers: {
    setAssignments: (state, action: PayloadAction<SubscriptionAssignment[]>) => {
      state.assignments = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    markWelcomeModalShown: (state) => {
      state.hasShownWelcomeModal = true;
    },
    markPaymentMethodsLoaded: (state) => {
      state.hasEverLoadedPaymentMethods = true;
    },
    resetUIFlags: (state) => {
      state.hasShownWelcomeModal = false;
      state.hasEverLoadedPaymentMethods = false;
    },
    clearAssignments: (state) => {
      state.assignments = [];
      state.isLoading = false;
      state.error = null;
    },
    openPlanSelectionModal: (state) => {
      state.showPlanSelectionModal = true;
    },
    openPlanSelectionModalWithPlan: (state, action: PayloadAction<string>) => {
      state.showPlanSelectionModal = true;
      state.preSelectedPlanId = action.payload;
    },
    closePlanSelectionModal: (state) => {
      state.showPlanSelectionModal = false;
      state.preSelectedPlanId = undefined;
    },
  },
  // When the API is ready, we can add extraReducers to handle API responses
  // extraReducers: (builder) => {
  //   builder.addMatcher(subscriptionAssignmentApi.endpoints.getAssignments.matchFulfilled, (state, { payload }) => {
  //     state.assignments = payload.data;
  //     state.isLoading = false;
  //   });
  // },
});

export default subscriptionAssignmentSlice.reducer;
export const {
  setAssignments,
  setLoading,
  setError,
  markWelcomeModalShown,
  markPaymentMethodsLoaded,
  resetUIFlags,
  clearAssignments,
  openPlanSelectionModal,
  openPlanSelectionModalWithPlan,
  closePlanSelectionModal,
} = subscriptionAssignmentSlice.actions;
